import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locale'
import topic from './utils/topic'
import $http from './fetch'
import directives from './directives'
import { Message } from 'axel-ui'
import './icons'

Vue.prototype.$topic = topic
Vue.prototype.$http = $http
Vue.prototype.$message = Message

Vue.config.productionTip = false

Vue.use(directives)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
